import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PartnerMicrosoftAdsService} from '../../../../../services/partner/partner-microsoft-ads.service';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';

@Component({
  selector: 'app-microsoft-ads-auth-redirect',
  imports: [],
  templateUrl: './microsoft-ads-auth-redirect.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './microsoft-ads-auth-redirect.component.scss',
})
@MetaTitle('Microsoft Ads Authentication Redirect')
export class MicrosoftAdsAuthRedirectComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private partnerMicrosoftAdsService: PartnerMicrosoftAdsService,
    private snackbar: SnackbarService,
  ) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['state']) {
        const result = params['state'].match(/^partner_([0-9]+)_/);
        const partnerId = result[1];

        this.partnerMicrosoftAdsService.setAuthenticationRedirect(window.location.href).subscribe({
          next: () => {
            this.snackbar.success('Authentication succeeded');
            this.router.navigate([`/partners/${partnerId}/account-management`]).then();
          },
          error: () => {
            this.router.navigate([`/partners/${partnerId}/account-management`]).then();
          }
        });
      }
    })
  }
}
